import { KImage, KText } from '@/ui-library/components';
import { Flex, Box, Link } from '@chakra-ui/react';

export const UserCard = ({ contact = {} }) => {
  const { id, first_name, last_name, image_url } = contact || {};
  return (
    <Flex flex="1">
      <KImage
        src={image_url}
        name={`${first_name} ${last_name}`}
        backgroundStyles={{ minWidth: '20px', minHeight: '20px' }}
      ></KImage>

      <Box flex="1" pl="12px" width="180px">
        {id ? (
          <Link href={`/contacts/${id}`} target="_blank">
            <KText
              width="100%"
              wordBreak="break-word"
              _hover={{
                textDecoration: 'underline',
                color: 'primary-500',
                cursor: 'pointer',
              }}
            >
              {`${first_name} ${last_name}`}
            </KText>
          </Link>
        ) : (
          <KText width="100%" wordBreak="break-word">
            {`${first_name} ${last_name}`}
          </KText>
        )}
        <KText fontSize="14px" fontWeight="400">
          {contact?.local_email || contact?.email?.[0]}
        </KText>
      </Box>
    </Flex>
  );
};
